import LeadMain from './LeadMain.container'
export default LeadMain



// WEBPACK FOOTER //
// ./src/pages/lead/index.js